<script setup>
import { isEmpty, isNull } from 'lodash'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import HomepageSidebarSegmentTitle from '@/components/home-page/HomepageSidebarSegmentTitle'
import {
  SIDEBAR_SEARCH_RESULTS_TEST_ID,
  SIDEBAR_SEARCH_TEST_ID
} from '@/components/home-page/jest-helpers'
import AppSearch from '@/components/ui/Search/Search'

defineOptions({
  name: 'HomepageSidebarFilterLayout'
})

const props = defineProps({
  searchResults: {
    type: Array,
    default: null
  }
})

const searchString = defineModel({
  type: String,
  required: true
})

const { t } = useI18n()

const isSearchResultsExist = computed(() => !isNull(props.searchResults))
const isEmptySearchResults = computed(
  () => isSearchResultsExist.value && isEmpty(props.searchResults)
)
</script>

<template>
  <div class="hpfl-Wrapper">
    <AppSearch
      v-model="searchString"
      :data-auto-testid="SIDEBAR_SEARCH_TEST_ID"
      :data-testid="SIDEBAR_SEARCH_TEST_ID"
      class="hpfl-Search"
    />

    <template v-if="isSearchResultsExist">
      <HomepageSidebarSegmentTitle>
        {{ t('placeholder.search_results') }}
      </HomepageSidebarSegmentTitle>

      <div
        :data-auto-testid="SIDEBAR_SEARCH_RESULTS_TEST_ID"
        :data-testid="SIDEBAR_SEARCH_RESULTS_TEST_ID"
        class="hpfl-SearchResults"
      >
        <slot v-if="isEmptySearchResults" name="no-results" />

        <slot v-else name="search-results" />
      </div>
    </template>

    <slot v-else />
  </div>
</template>

<style lang="scss" scoped>
.hpfl-Wrapper {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.hpfl-Search {
  margin: 0 var(--ob-hps-mx) var(--ob-hpgf-item-gap);
  min-height: 0;
}

.hpfl-SearchResults {
  flex: 1;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding-inline: var(--ob-hps-mx);
}
</style>
